import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  Drawer,
  Box,
  Typography,
  Button,
  DrawerProps,
  SxProps,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StrengthWeaknessItem } from '../PerformanceDrawer/performanceDrawerData';
import { SWItem } from '../SWItem';

export const StrengthWeaknessGroup = ({
  title,
  icon,
  items,
  variant,
  emptyState,
}: {
  title: string;
  icon: string;
  items?: StrengthWeaknessItem[];
  variant: 'strengths' | 'weaknesses';
  emptyState?: string;
}) => {
  const { t } = useTranslation();
  const theme =
    variant === 'strengths' ? { color: '#15803d' } : { color: '#b45309' };

  const isEmpty = !items || items.length === 0;

  return (
    <Box sx={{ mb: pxToRem(14) }}>
      {/* HEADER */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: pxToRem(6),
          mb: pxToRem(8),
        }}
      >
        <Typography>{icon}</Typography>

        <Typography
          sx={{
            fontSize: pxToRem(13),
            fontWeight: 700,
            color: theme.color,
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* CONTENT */}
      <Box display="flex" flexDirection="column" gap={pxToRem(8)}>
        {isEmpty ? (
          <Typography
            sx={{
              fontSize: pxToRem(12),
              color: '#94a3b8',
              fontStyle: 'italic',
              textAlign: 'center',
              py: pxToRem(6),
            }}
          >
            {emptyState}
          </Typography>
        ) : (
          items.map((item) => (
            <SWItem
              key={item.name}
              icon={item.icon}
              title={item.name}
              variant={variant}
              bloomLevel={item.bloomLevel}
              bloomLevels={item.bloomLevels}
              subtitle={
                variant === 'strengths'
                  ? t('PAL_SW_STRENGTH_SUBTITLE', {
                      accuracy: item.accuracy,
                      correct: item.correct,
                      total: item.correct + item.incorrect,
                    })
                  : t('PAL_SW_WEAKNESS_SUBTITLE', {
                      accuracy: item.accuracy,
                      incorrect: item.incorrect,
                      total: item.correct + item.incorrect,
                    })
              }
            />
          ))
        )}
      </Box>
    </Box>
  );
};
